import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import ProgressUI from '../../../widgets/output/ProgressUI'
import AvatarAndNameUI from '../../../widgets/output/AvatarAndNameUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LabelAndValue2UI from '../../../widgets/layout/LabelAndValue2UI'
import NameAndEditUI from '../../../widgets/layout/NameAndEditUI'
import RequestFundModalSF from './RequestFundModalSF'
import BudgetUpdateModalSF from './BudgetUpdateModalSF'


const BudgetHeaderUI = ({ context, messageList, order, budget,
  requestFundMode, onRequestFundClick, onRequestFundCancel, onRequestFundComplete,
  onUpdateClick, updateMode, onCancelClick, onUpdateComplete
}) =>
  <React.Fragment>
    <div className='g_flex_h'>
      <div>
        <NameAndEditUI name={budget.budgetName} onUpdateClick={onUpdateClick} />
        <div className='g_small'>{order.customerName}</div>
        <div className='g_small'>{order.orderName}</div>
      </div>
    </div>
    <div className='g_flex_h g_m_top_50'>
      <div className='g_m_top_50'>
        <AvatarAndNameUI avatarUrl={budget.avatarUrl}
          userName={budget.userName} userLeft={budget.userLeft}
        />
      </div>
      <LabelAndValueUI messageList={messageList} labelKey='c_allocated' align='right'>
        {budget.assignedAmountF2}
      </LabelAndValueUI>
    </div>
    <div className='g_flex_h g_m_top_50'>
      <ProgressUI messageList={messageList} labelKey='c_utilized' percent={budget.spentAmountPercent} />
      <LabelAndValueUI messageList={messageList} labelKey='c_utilized' align='right'>
        {budget.spentAmountF2}
      </LabelAndValueUI>
    </div>
    {
      budget.userId === context.session.userId &&
      <CardUI>
        <div className='g_flex_h'>
          <div>
            {
              budget.requestAmount !== null && budget.requestAmount !== 0 &&
              <React.Fragment>
                <LabelAndValue2UI messageList={messageList} labelKey='c_request_amount'>
                  {budget.requestAmountF2}
                </LabelAndValue2UI>
                <LabelAndValue2UI messageList={messageList} labelKey='c_request_date'>
                  {budget.requestDateF1}
                </LabelAndValue2UI>
                {
                  budget.requestDueDateF1 &&
                  <LabelAndValue2UI messageList={messageList} labelKey='c_required_by'>
                    {budget.requestDueDateF1}
                  </LabelAndValue2UI>
                }
              </React.Fragment>
            }
          </div>
          <div className='g_text_right g_m_top_50'>
            <ButtonUI messageList={messageList} labelKey='c_request_fund' onClick={onRequestFundClick} />
          </div>
        </div>
      </CardUI>
    }

    <BudgetUpdateModalSF context={context} budget={budget}
      updateMode={updateMode} onCancelClick={onCancelClick} onUpdateComplete={onUpdateComplete}
    />

    <RequestFundModalSF context={context} budget={budget}
      requestFundMode={requestFundMode} onCancelClick={onRequestFundCancel}
      onRequestComplete={onRequestFundComplete}
    />

  </React.Fragment>

export default BudgetHeaderUI
